import { useCreateIssueMode } from "#app/lib/create-issue-context";
import { useIssueViewCapabilities } from "#app/components/issue-view/issue-view-capabilities";
import { SummaryCustomFieldsHeaderActions } from "#app/widgets/summary/custom-fields-header-actions";
import { useIssueWidgetContext } from "#app/widgets/issue/issue-widget-context";

export function IssueCustomFieldsHeaderActions() {
  const ctx = useIssueWidgetContext();
  const createCtx = useCreateIssueMode();
  const { canEdit } = useIssueViewCapabilities();
  return (
    <SummaryCustomFieldsHeaderActions
      // A create draft adds fields into its own values; a read-only viewer
      // cannot write the added field's default — the search stays.
      canAddFields={!!createCtx || canEdit}
      customFields={ctx.customFields}
      locationName={createCtx ? createCtx.draft.name : ctx.issue?.name}
      onUpdateValue={ctx.onUpdateValue}
      orderedTypeFieldIds={ctx.orderedTypeFieldIds}
      values={ctx.values}
    />
  );
}
